var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMageElectricityFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8368 10.4861C19.814 10.6599 19.741 10.8233 19.6268 10.9561L9.87678 21.6661C9.75316 21.8259 9.58133 21.9417 9.38678 21.9961C9.30345 22.0061 9.22012 22.0061 9.13678 21.9961C8.99529 21.9955 8.85554 21.9648 8.72678 21.9061C8.5263 21.812 8.36652 21.6486 8.27678 21.4461C8.1896 21.266 8.16497 21.0619 8.20678 20.8661L9.06678 14.0061H5.43678C5.22929 13.9933 5.02593 13.9424 4.83678 13.8561C4.65165 13.7586 4.49301 13.6176 4.37454 13.4451C4.25607 13.2726 4.18134 13.0739 4.15678 12.8661C4.13579 12.6552 4.16669 12.4424 4.24678 12.2461L8.02678 2.79614C8.12678 2.55714 8.29278 2.35214 8.50678 2.20614C8.72094 2.06693 8.97136 1.99389 9.22678 1.99614H16.4668C16.6758 2.00014 16.8808 2.05114 17.0668 2.14614C17.2548 2.25114 17.4158 2.39914 17.5368 2.57614C17.6488 2.75514 17.7168 2.95614 17.7368 3.16614C17.7573 3.37472 17.7228 3.58503 17.6368 3.77614L15.2468 9.34614H18.8968C19.0782 9.35221 19.2544 9.40752 19.4068 9.50614C19.5674 9.61349 19.6935 9.76505 19.7698 9.94251C19.8461 10.12 19.8694 10.3157 19.8368 10.5061V10.4861Z",
    fill: "#C68A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageElectricityFill);
export default __webpack_public_path__ + "static/media/mage_electricity-fill.c455def54dc44fa8673c3c7b6e4b5717.svg";
export { ForwardRef as ReactComponent };